<template>
  <div class="questions">
    <div class="headerImg">
        <div class="search" @click="jumpSearch">
           <i class="el-icon-search"></i> 请输入关键词
        </div>
    </div>
    <div class="tabsBox">
        <div class="tabs">
            <div class="tabsSelect">
                <span class="hottest" @click="changeActive(0)" :class="{active:activeName==0?true:false}">
                    最热
                </span>
                <span class="latest" @click="changeActive(1)" :class="{active:activeName==1?true:false}">
                    最新
                </span>
            </div>
        </div>
        <div v-if="activeName == 0" class="pubBox">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDetailList" >
                <van-cell >
                    <div class="item" v-for="(item,index) in reporterList" :key="index" >
                        <div class="itemTitle" @click="jumpUrl(item.webIntQaId)">
                            {{item.webIntQaTitle}}
                        </div>
                        <div class="userMsg">
                            <img :src="item.createUserAvatar?getimgUrl(item.createUserAvatar):require('@/assets/questionsAndAnswer/user.png')" alt="" @click="jumpUserUrl(item.createUser)">
                            <div class="userName">
                                {{item.createUserName}}
                            </div>
                        </div>
                        <!-- 纯文本展示 -->
                        <div class="question" v-if="item.webIntQaContent" @click="jumpUrl(item.webIntQaId)"> 
                            {{item.webIntQaContent}}
                        </div>
                        <!-- 图片列表展示 -->
                        <div class="picture" v-if="item.webAttType==4" @click="jumpUrl(item.webIntQaId)">
                            <div class="onePicture" v-if="item.fileObjIds && item.fileObjIds.length==1" >
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                            </div>
                            <div class="twoPicture" v-if="item.fileObjIds && item.fileObjIds.length==2" >
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[1]):''" alt="">
                            </div>
                            <div class="morePicture" v-if="item.fileObjIds && item.fileObjIds.length>2" >
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                                <div class="picRight">
                                    <div class="top">
                                        <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[1]):''" alt="">
                                    </div>
                                    <div class="bottom" style="position: relative;">
                                        <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[2]):''" alt="">
                                        <div style="width: 36px;height: 20px;position: absolute;bottom: 8px;right: 8px;background-color: rgba(0,0,0,.3);
                                            text-align: center;font-size: 12px;border-radius: 10px;color: #fff;">
                                            {{item.fileObjIds.length}}图
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 视频展示 -->
                        <div class="picture" v-if="item.webAttType==2" @click="jumpUrl(item.webIntQaId)" style="position: relative;">
                            <div class="onePicture" >
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                            </div>
                            <div class="playPic" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
                                <img src="@/assets/questionsAndAnswer/playVideo.png" alt="">
                            </div>
                        </div>
                        <div class="footer">
                            <div class="createTime">
                                {{item.createTime}}
                            </div>
                            <div class="replyNum">
                                <div class="replyPic">
                                    <img src="@/assets/questionsAndAnswer/huifu.png" alt="">
                                </div>
                                <div >{{item.replyCount?item.replyCount:'--'}}</div>
                            </div>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </div>
        <div v-else class="pubBox">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDetailList" >
                <van-cell >
                    <div class="item" v-for="(item,index) in newList" :key="index">
                        <div class="itemTitle" @click="jumpUrl(item.webIntQaId)">
                            {{item.webIntQaTitle}}
                        </div>
                        <div class="userMsg" @click="jumpUserUrl(item.createUser)">
                            <img :src="item.createUserAvatar?getimgUrl(item.createUserAvatar):require('@/assets/questionsAndAnswer/user.png')" alt="" @click="jumpUserUrl(item.createUser)">
                            <div class="userName">
                                {{item.createUserName}}
                            </div>
                        </div>
                        <!-- 纯文本展示 -->
                        <div class="question" v-if="item.webIntQaContent" @click="jumpUrl(item.webIntQaId)"> 
                            {{item.webIntQaContent}}
                        </div>
                        <!-- 图片列表展示 -->
                        <div class="picture " v-if="item.webAttType==4" @click="jumpUrl(item.webIntQaId)">
                            <div class="onePicture" v-if="item.fileObjIds && item.fileObjIds.length==1">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                            </div>
                            <div class="twoPicture" v-if="item.fileObjIds && item.fileObjIds.length==2">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[1]):''" alt="">
                            </div>
                            <div class="morePicture" v-if="item.fileObjIds && item.fileObjIds.length>2">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                                <div class="picRight">
                                    <div class="top">
                                        <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[1]):''" alt="">
                                    </div>
                                    <div class="bottom" style="position: relative;">
                                        <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[2]):''" alt="">
                                        <div style="width: 36px;height: 20px;position: absolute;bottom: 8px;right: 8px;background-color: rgba(0,0,0,.3);
                                            text-align: center;font-size: 12px;border-radius: 10px;color: #fff;">
                                            {{item.fileObjIds.length}}图
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 视频展示 -->
                        <div class="picture" v-if="item.webAttType==2" @click="jumpUrl(item.webIntQaId)" style="position: relative;">
                            <div class="onePicture">
                                <img :src="item.fileObjIds?getimgUrl(item.fileObjIds[0]):''" alt="">
                            </div>
                            <div class="playPic" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
                                <img src="@/assets/questionsAndAnswer/playVideo.png" alt="">
                            </div>
                        </div>
                        <div class="footer">
                            <div class="createTime">
                                {{item.createTime}}
                            </div>
                            <div class="replyNum">
                                <div class="replyPic">
                                    <img src="@/assets/questionsAndAnswer/huifu.png" alt="">
                                </div>
                                <div >{{item.replyCount?item.replyCount:'--'}}</div>
                            </div>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
    <div class="bottomBox">
        <div class="itemBody">
            <div class="leftBtn" @click="jumpAskingQuestion"> 提问</div>
            <div class="rightBtn" @click="jumpMyQandA">我的提问</div>
        </div>
        
    </div>
  </div>
</template>

<script>
import {
  appOrh5Login
} from "@/utils/app";
import { mapState, mapMutations } from "vuex";
import {getLoginStatus} from "@/utils/app.js"
import { filePerviewPath } from "@/api/ActivitySolicitation/index.js";
import { interactiveqaPage,interactiveqaHotpage } from "@/api/questionsAndAnswer/index.js"
import { Toast } from 'vant';
export default {
    data(){
        return{
            activeName:0, // tabs高亮
            pageNum: 0, // 页码
            pageSize:10, // 每页条数
            reporterList: [], // 最热list数据
            newList:[], // 最新数据
            finished:true, // 触底加载底部显示
            loading:false, 
            imgArr:[], //  图片地址
            webTenId:'', // 租户id
            userLoginStatus:'' , //登录态
        }
    },
    computed: {
        ...mapState(["loginStatus"])
    },  
    created() {
    },
    mounted() {
        document.title="问答"
        this.webTenId = this.$route.query.webTenId;
        this.getDetailList()
    },
    methods: {
        ...mapMutations(["setInWx", "setInIOS", "setInAndroid", "setNeedLoginType","setloginStatus"]),
        // 点击切换
        changeActive(val){
            this.activeName = val
            this.pageNum = 0
            this.reporterList=[]
            this.newList=[]
            this.getDetailList()
        },
        // 获取列表数据
       getDetailList(){
        this.pageNum++
        if(this.activeName == 1){
            let params={
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                webAudStatus:1
            }
            this.loading = true
            interactiveqaPage(params).then(res=>{
                if(res.data.code == 200 ){
                    this.loading = false
                    this.newList.push(...res.data.data.list) 
                }else{
                    Toast(res.data.msg)
                }
            })
        }else{
            let params={
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                webAudStatus:1
            }
            this.loading = true
            interactiveqaHotpage(params).then(res=>{
                if(res.data.code == 200 ){
                    this.loading = false
                    this.reporterList.push(...res.data.data.list) 
                }else{
                    Toast(res.data.msg)
                }
            })
        }
            
       },
        // 点击问题跳转详情
        jumpUrl(val){
            window.open('/questionsDetails?id=' + val + '&&webTenId=' + this.webTenId,'_self')
        },
        // 跳转用户详情
        jumpUserUrl(val){
            window.open('/userQuestionsAnswer?webUserId='+val,'_self')
        },
        // 跳转到我的提问
        jumpMyQandA(){
            this.getMyLoginStatus()
            if(this.userLoginStatus == 0){
                his.getMyLoginStatus()
            }else if(this.userLoginStatus == 1){
                window.open('/userQuestionsAnswer?user=user','_self')
            }
        },
        // 跳转到提问页面
        jumpAskingQuestion(){
            this.getMyLoginStatus()
            if(this.userLoginStatus == 0){
                this.getMyLoginStatus()
            }else if(this.userLoginStatus == 1){
                window.open('/askingQuestions?webTenId=' + this.webTenId  ,'_self')
            }
        },
        // 跳转搜索页面
        jumpSearch(){
            window.open('/search','_self')
        },
        //获取图片
        getimgUrl(val) {
            if(val){
                return filePerviewPath({
                        id: val,
                        type: "cover"
                    });
            }
        },
        //获取登录状态
        getMyLoginStatus () {
            this.setNeedLoginType(true);
            appOrh5Login('questions');
            this.userLoginStatus = localStorage.getItem('userLoginStatus');
        },
        
    },
}
</script>

<style scoped lang="scss">
.questions{
    width:100%;
    min-height: 100vh;
}
.headerImg{
    position: relative;
    width: 100%;
    height: 265px;
    background-image: url(../../assets/questionsAndAnswer/beijing.png);
    background-repeat: no-repeat;
    background-size: 100%;
}
.search{
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 80%;
    height: 36px;
    line-height: 36px;
    text-align: center;
    overflow: hidden;
    border-radius: 20px;
    font-size: 14px;
    color: #fff;
    background-color: rgba(255,255,255,.6);
}
.tabsBox{
    position: relative;
    margin-top: -60px;
    background-color: #fff;
    width: 100%;
    
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
.tabs{
    width: 90%;
    margin: 0 auto;
}
.tabsSelect{
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    // padding-top: 16px;
    text-align: center;
}
.hottest,.latest{
    color: #333333;
    font-size: 16px;
}
.hottest{
    margin-right: 77px;
}
.active{
    position: relative;
    font-size: 18px;
    font-weight: bold;
}
.active::after{
    content: '';
    position: absolute;
    bottom: -12px;
    width: 12px;
    height: 4px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url(../../assets/questionsAndAnswer/xuanzhong.png);
}
.pubBox{
    width: 92%;
    margin: 0 auto;
    margin-top: 16px;
    height: 60vh;
    overflow: hidden;
    overflow-y: auto;
    /deep/ .van-cell{
        padding: 0;
    }
}
.item{
    width: 100%;
    background-color: #F8F9FD;
    box-sizing: border-box;
    padding: 16px 20px;
    margin-bottom: 12px;
    border-radius: 6px;
    .itemTitle{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .userMsg{
        display: flex;
        align-items: center;
        width: 100%;
        height: 36px;
        margin-top: 20px;
        margin-bottom: 12px;
    }
    .userMsg img{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
    }
    .userName{
        margin-left: 7px;
        color: #000;
    }
    .question{
        width: 100%;
        font-size: 14px;
        color: #666;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .picture{
        margin-top: 10px;
        width: 100%;
        .playPic{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 32px;
                height: 32px;
                transform: translate(-50%,-50%);
                img{
                    width: 32px;
                    height: 32px;
                }
            }
    }
    .onePicture{
        width: 100%;
        height: 190px;
        text-align: center;
    }
    .onePicture img{
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
    }
    .twoPicture{
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: space-between;
    }
    .twoPicture img{
        width: 48%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
    }
    .morePicture{
        width: 100%;
        height: 163px;
        display: flex;
        justify-content: space-between;
    }
    .morePicture img{
        width: 48%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
    }
    .picRight{
        width: 48%;
        height: 100%;
    }
    .picRight .top{
        width: 100%;
        height: 48%;
        margin-bottom: 11px;
    }
    .picRight .bottom{
        width: 100%;
        height: 48%;
    }
    .picRight .top img{
        width: 100%;
        height: 100%;
    }
    .picRight .bottom img{
        width: 100%;
        height: 100%;
    }
    .footer{
        width: 100%;
        height: 17px;
        line-height: 17px;
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999999;
        .createTime{
            font-size: 14px;
        }
        .replyNum{
            display: flex;
            align-items: center;
            font-size: 14px;
            .replyPic{
                width: 14px;
                height: 14px;
                margin-right:4px;
                img{
                    width: 14px;
                    height: 14px;
                }
            }
        }
    }
    
}
.bottomBox{
    width: 100%;
    max-width: 460px;
    height: 50px;
    position: fixed;
    bottom: 0px;
    .itemBody{
        display: flex;
        justify-content: space-around;
        margin:0 auto;
    }
    .leftBtn{
        width: 45%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background-color: #347CCF;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        border-radius: 29px;
    }
    .rightBtn{
        width: 45%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background-color: #D6E9FF;
        font-size: 18px;
        font-weight: bold;
        color: #347CCF;
        border-radius: 29px;
    }
}

</style>